import selectors from '@/redux/selectors/selectors';
import useAppsMetadata from '@/hooks/useAppsMetadata';
import utilityAppIcons from '@/screens/workflows/schema/utilityAppIcons.js';
import { FiStar } from '@/components/react-icons/main/index.esm';
import { getCredentialsByCompany } from '@/redux/actions/gravityActions';
import { useEffect, useCallback } from 'react';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';

const useCredentialMapping = (companyId) => {
  const credentials = useArgSelector(selectors.credentialsByCompany, companyId);
  const appsMetadata = useAppsMetadata();
  const isLoading = useArgSelector(selectors.isLoading, `getCredentials-${companyId}`);

  useEffect(() => {
    if (!companyId) {
      return;
    }
    getCredentialsByCompany({ companyId });
  }, [companyId]);

  const credentialMap = useCallback(
    ({ items }) => {
      if (!items?.length || !credentials?.length || !appsMetadata?.length) {
        return [];
      }

      return items.map((item) => {
        const cred = credentials.find((cred) => cred.credentialId === item.credentialId);
        const app = appsMetadata.find((a) => a.id === cred?.appId);
        const icon = app?.icon || utilityAppIcons[app?.slug] || FiStar;
        return {
          id: item.credentialId,
          label: cred?.meta?.label || app?.name || 'Unknown Credential',
          appName: app?.name || app?.slug || 'Unknown App',
          icon,
          credential: cred
        };
      });
    },
    [credentials, appsMetadata]
  );

  return { credentialMap, isLoading };
};

export default useCredentialMapping;
